/*
 * App Registry Loader (Server)
 * Falls back to UAT defaults if the app registry is missing.
 */

try {
    module.exports = require("../../.includes/uat.registry.server.js");
} catch (error) {
    console.log("App registry (server) not found. Falling back to UAT defaults.", {
        error: error
    });
    module.exports = require("./registry.server.js");
}
